import { bigram } from 'n-gram';
import ConditionUnit from '../entities/ConditionUnit';
import { DefaultInnerStatusJp } from "../entities/InnerStatus";
import { TicketStatus } from '../entities/Ticket';
import TicketField, { FieldType } from '../entities/TicketField';
import { hoursToMinutes, toDate, ymdhmsStoreFormat } from './datetime';
import { buildHeaderFrom } from './email';


export const DefaultFieldCodes = {
  id: 'id',
  supportEmail: 'supportEmail',
  title: 'title',
  emailFrom: 'emailFrom',
  emailTo: 'emailTo',
  agent: 'agent',
  ticketStatus: 'ticketStatus',
  innerStatus: 'innerStatus',
  startedAt: 'startedAt',
  closedAt: 'closedAt',
  lastUpdatedAt: 'lastUpdatedAt',
  lastReceivedAt: 'lastReceivedAt',
  lastSentAt: 'lastSentAt',
  ticketRoute: 'ticketRoute',
  formCustomerName: 'formCustomerName',
  text: 'text',
  category: 'category',
  reason: 'reason'
}

export const DefaultFieldNames = {
  id: 'ID',
  supportEmail: '転送先アドレス',
  title: '件名',
  emailFrom: 'from',
  emailTo: 'to',
  agent: '担当者',
  ticketStatus: 'ステータス',
  innerStatus: '内部ステータス',
  startedAt: '開始日時',
  closedAt: '完了日時',
  lastUpdatedAt: '最終更新日時',
  lastReceivedAt: '最終受信日時',
  lastSentAt: '最終送信日時',
  ticketRoute: 'お問い合せ経路',
  formCustomerName: 'フォームカスタマー名',
  text: 'お問い合わせ内容',
  category: '管理種別',
  reason: 'お問い合わせ理由',
}

export const getDefaultTicketFields = () => {
  return [
    { name: 'ID', code: 'id', type: FieldType.String},
    { name: '転送先アドレス', code: 'supportEmail', type: FieldType.String},
    { name: '件名', code: 'title', type: FieldType.String},
    { name: 'from', code: 'emailFrom', type: FieldType.String},
    { name: 'phone', code: 'phone', type: FieldType.String},
    { name: 'to', code: 'emailTo', type: FieldType.ArrayString},
    { name: '担当者', code: 'agent', type: FieldType.Agent},
    { name: 'ステータス', code: 'ticketStatus', type: FieldType.SingleSelect, values: Object.values(TicketStatus)},
    { name: '内部ステータス', code: 'innerStatus', type: FieldType.SingleSelect, values: Object.values(DefaultInnerStatusJp)},
    { name: '開始日時', code: 'startedAt', type: FieldType.Datetime},
    { name: '完了日時', code: 'closedAt', type: FieldType.Datetime},
    { name: '最終更新日時', code: 'lastUpdatedAt', type: FieldType.Datetime},
    { name: '最終受信日時', code: 'lastReceivedAt', type: FieldType.Datetime},
    { name: '最終送信日時', code: 'lastSentAt', type: FieldType.Datetime},
    { name: 'お問い合せ経路', code: 'ticketRoute', type: FieldType.Radio, values: ['web', 'email', 'chat', 'agent']},
    { name: 'フォームカスタマー名', code: 'formCustomerName', type: FieldType.String},
    { name: 'お問い合わせ内容', code: 'text', type: FieldType.Textarea},
  ] as TicketField[]
}

export const getDefaultTicketFieldsForView = () => {
  return [
    { name: 'ID', code: 'id', type: FieldType.String},
    { name: '転送先アドレス', code: 'supportEmail', type: FieldType.String},
    { name: '件名', code: 'title', type: FieldType.String},
    { name: 'from', code: 'emailFrom', type: FieldType.String},
    { name: 'phone', code: 'phone', type: FieldType.String},
    { name: 'to', code: 'emailTo', type: FieldType.ArrayString},
    { name: '担当者', code: 'agent', type: FieldType.Agent},
    { name: 'ステータス', code: 'ticketStatus', type: FieldType.SingleSelect, values: Object.values(TicketStatus)},
    { name: '内部ステータス', code: 'innerStatus', type: FieldType.SingleSelect, values: Object.values(DefaultInnerStatusJp)},
    { name: '開始日時', code: 'startedAt', type: FieldType.Datetime},
    { name: '完了日時', code: 'closedAt', type: FieldType.Datetime},
    { name: '最終更新日時', code: 'lastUpdatedAt', type: FieldType.Datetime},
    { name: '最終受信日時', code: 'lastReceivedAt', type: FieldType.Datetime},
    { name: '最終送信日時', code: 'lastSentAt', type: FieldType.Datetime},
    { name: 'お問い合せ経路', code: 'ticketRoute', type: FieldType.Radio, values: ['web', 'email', 'chat', 'agent']},
    { name: 'フォームカスタマー名', code: 'formCustomerName', type: FieldType.String},
    { name: 'お問い合わせ内容', code: 'text', type: FieldType.Textarea},
    { name: '管理種別1', code: 'category_1', type: FieldType.Category + "_1", values: []},
    { name: '管理種別2', code: 'category_2', type: FieldType.Category + "_2", values: []},
    { name: '管理種別3', code: 'category_3', type: FieldType.Category + "_3", values: []},
    { name: 'お問い合わせ理由1', code: 'reason_1', type: FieldType.Reason + "_1", values: []},
    { name: 'お問い合わせ理由2', code: 'reason_2', type: FieldType.Reason + "_2", values: []},
    { name: 'お問い合わせ理由3', code: 'reason_3', type: FieldType.Reason + "_3", values: []},
  ]
}

export const getDefaultLayoutTicketFields = () => {
  return [
    { name: '転送先アドレス', code: 'supportEmail', type: FieldType.String},
    { name: '開始日時', code: 'startedAt', type: FieldType.Datetime},
    { name: '完了日時', code: 'closedAt', type: FieldType.Datetime},
    { name: '最終更新日時', code: 'lastUpdatedAt', type: FieldType.Datetime},
    { name: '最終受信日時', code: 'lastReceivedAt', type: FieldType.Datetime},
    { name: '最終送信日時', code: 'lastSentAt', type: FieldType.Datetime},
    { name: '件名', code: 'title', type: FieldType.String},
    { name: 'フォームカスタマー名', code: 'formCustomerName', type: FieldType.String},
    { name: 'from', code: 'emailFrom', type: FieldType.String},
    { name: 'phone', code: 'phone', type: FieldType.String},
    { name: 'to', code: 'emailTo', type: FieldType.ArrayString},
    { name: '担当者', code: 'agent', type: FieldType.Agent},
    { name: 'ステータス', code: 'ticketStatus', type: FieldType.SingleSelect, values: Object.values(TicketStatus)},
    { name: '内部ステータス', code: 'innerStatus', type: FieldType.SingleSelect, values: Object.values(DefaultInnerStatusJp)},
  ] as TicketField[]
}

export const getDefaultLayoutTicketCreateFields = () => {
  return [
    { name: '転送先アドレス', code: 'supportEmail', type: FieldType.String},
    { name: '件名', code: 'title', type: FieldType.String},
    { name: 'from', code: 'emailFrom', type: FieldType.String},
    { name: 'phone', code: 'phone', type: FieldType.String},
    { name: 'to', code: 'emailTo', type: FieldType.ArrayString},
    { name: '担当者', code: 'agent', type: FieldType.Agent},
    { name: 'ステータス', code: 'ticketStatus', type: FieldType.SingleSelect, values: Object.values(TicketStatus)},
    { name: '内部ステータス', code: 'innerStatus', type: FieldType.SingleSelect, values: Object.values(DefaultInnerStatusJp)},
    // { name: 'お問い合せ経路', code: 'ticketRoute', type: FieldType.Radio, values: ['web', 'email', 'chat', 'agent']},
    { name: 'フォームカスタマー名', code: 'formCustomerName', type: FieldType.String},
  ] as TicketField[]
}

export const getDefaultAllTicketFields = () => {
  return [
    { name: 'ID', code: 'id', type: FieldType.String},
    { name: 'ファーストメッセージID', code: 'firstMessageId', type: FieldType.String },
    { name: '転送先アドレス', code: 'supportEmail', type: FieldType.String},
    { name: '件名', code: 'title', type: FieldType.String},
    { name: 'from', code: 'emailFrom', type: FieldType.String},
    { name: 'phone', code: 'phone', type: FieldType.String},
    { name: 'to', code: 'emailTo', type: FieldType.ArrayString},
    { name: '担当者', code: 'agent', type: FieldType.Agent},
    { name: 'ステータス', code: 'ticketStatus', type: FieldType.SingleSelect, values: Object.values(TicketStatus)},
    { name: '内部ステータス', code: 'innerStatus', type: FieldType.SingleSelect, values: Object.values(DefaultInnerStatusJp)},
    { name: '開始日時', code: 'startedAt', type: FieldType.Datetime},
    { name: '完了日時', code: 'closedAt', type: FieldType.Datetime},
    { name: '最終更新日時', code: 'lastUpdatedAt', type: FieldType.Datetime},
    { name: '最終受信日時', code: 'lastReceivedAt', type: FieldType.Datetime},
    { name: '最終送信日時', code: 'lastSentAt', type: FieldType.Datetime},
    { name: 'お問い合せ経路', code: 'ticketRoute', type: FieldType.Radio, values: ['web', 'email', 'chat', 'agent']},
    { name: 'フォームカスタマー名', code: 'formCustomerName', type: FieldType.String},
    { name: 'お問い合わせ内容', code: 'text', type: FieldType.Textarea},
  ]
}

export const getDefaultLayoutFieldCodes = () => {
  return [
    'supportEmail',
    'emailTo',
    'emailFrom',
    'phone',
    'title',
    'agent',
    'ticketStatus',
    'innerStatus',
    'text'
  ]
}

export const getDefaultLayoutRequiredCodes = () => {
  return ['title', 'ticketStatus']
}

export const generateNewTicket = (supportEmail, headerFrom) => {
  const now = new Date()
  return {
    ticketStatus: TicketStatus.open,
    supportEmail: supportEmail,
    emailTo: [headerFrom],
    ticketRoute: 'agent',
  }
}

export const castTicketDate = (ticket, fields) => {
  const newTicket = { ...ticket }
  fields.forEach((field) => {
    if ([FieldType.Datetime, FieldType.Date, FieldType.Time].includes(field.type)) {
      newTicket[field.code] = toDate(newTicket[field.code])
    }
  })
  return newTicket;
}

export const toDisplayTicketDate = (ticket, fields) => {
  const newTicket = { ...ticket }
  fields.forEach((field) => {
    if ([FieldType.Datetime, FieldType.Date, FieldType.Time].includes(field.type)) {
      newTicket[field.code] = ymdhmsStoreFormat(toDate(newTicket[field.code]))
    }
  })
  return newTicket;
}

export const extractEmails = (text) => {
  if (!text) return null
  const emails = text?.match(/([a-zA-Z0-9\+._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi);
  if (emails && emails.length > 0) {
    return emails[0]
  } else {
    return null
  }
}

export const buildBigram = (text: string) => {
  const words = bigram(text)
  const map = {}
  words.forEach((word) => {
    map[word] = true
  })
  return map
}

export const c = {
  equal: (v1, v2) => {
    if (!v2) {
      return v1 == '' || !v1
    }
    return v1 == v2
  },
  notEqual: (v1, v2) => {
    if (!v2) {
      return !!v1
    }
    return v1 != v2
  },
  biggerThan: (v1, v2) => {
    return v1 > v2
  },
  biggerEqual: (v1, v2) => {
    return v1 >= v2
  },
  smallerThan: (v1, v2) => {
    return v1 < v2
  },
  smallerEqual: (v1, v2) => {
    return v1 <= v2
  },
  includes: (v1, v2) => {
    return v1?.includes(v2)
  },
  notIncludes: (v1, v2) => {
    return !v1?.includes(v2)
  },
  startsWith: (v1, v2) => {
    return v1?.startsWith(v2)
  },
  endsWith: (v1, v2) => {
    return v1?.endsWith(v2)
  },
  or: (m1, m2) => {
    return m1 || m2
  },
  and: (m1, m2) => {
    return m1 && m2
  }
}

export const ComparisonOperator = {
  equal: "equal",
  notEqual: "notEqual",
  biggerThan: "biggerThan",
  biggerEqual: "biggerEqual",
  smallerThan: "smallerThan",
  smallerEqual: "smallerEqual",
  includes: "includes",
  notIncludes: "notIncludes",
  startsWith: "startsWith",
  endsWith: "endsWith",
  checked: "checked",
  or: "or",
  and: "and"
}

export const ComparisonOperatorIcon = {
  equal: "=",
  notEqual: "!=",
  biggerThan: ">",
  biggerEqual: ">=",
  smallerThan: "<",
  smallerEqual: "<=",
  includes: "含む",
  notIncludes: "含まない",
  startsWith: "で、始まる",
  endsWith: "で、終わる",
  or: "or",
  and: "and"
}

export const UnitType = {
  group: 'group',
  condition: 'condition'
}

export const isTargetTicket = (condition, ticket) => {
  if (!condition) return []
  if (condition.unitType == UnitType.group) {
    return condition.children.map((child) => {
      return isTargetTicket(child, ticket)
    }).reduce((a, b) => c[condition.operation](a, b))
  } else {
    return getCondition(condition, ticket)
  }
}

export const getCondition = (condition, ticket) => {
  if ([FieldType.String, FieldType.SingleSelect, FieldType.Radio, FieldType.Agent, FieldType.Number].includes(condition.fieldType)) {
    return c[condition.operation](ticket[condition.fieldCode], condition.targetValue)
  } else if (condition.fieldType == FieldType.Datetime) {
    return c[condition.operation](toDate(ticket[condition.fieldCode]), toDate(condition.targetValue))
  } else if (condition.fieldType == FieldType.Date) {
    if ([ComparisonOperator.biggerThan, ComparisonOperator.smallerEqual].includes(condition.operation)) {
      const ticketDate = toDate(ticket[condition.fieldCode])
      const targetDate = toDate(condition.targetValue)
      targetDate.setHours(23)
      targetDate.setMinutes(59)
      targetDate.setSeconds(59)
      return c[condition.operation](ticketDate, targetDate)
    } else if ([ComparisonOperator.biggerEqual, ComparisonOperator.smallerThan].includes(condition.operation)) {
      const ticketDate = toDate(ticket[condition.fieldCode])
      const targetDate = toDate(condition.targetValue)
      targetDate.setHours(0)
      targetDate.setMinutes(0)
      targetDate.setSeconds(0)
      return c[condition.operation](ticketDate, targetDate)
    }
  } else if (condition.fieldType == FieldType.Time) {
    const ticketDate = toDate(ticket[condition.fieldCode])
    const ticketHour = ticketDate.getHours()
    const ticketMinutes = ticketDate.getMinutes()
    const targetDate = toDate(condition.targetValue)
    const targetHour = targetDate.getHours()
    const targetMinutes = targetDate.getMinutes()
    return c[condition.operation](hoursToMinutes(ticketHour, ticketMinutes), hoursToMinutes(targetHour, targetMinutes))
  } else if ([FieldType.Checkbox, FieldType.ArrayString].includes(condition.fieldType)) {
    return c[condition.operation](ticket[condition.fieldCode], condition.targetValue)
  } else if ([FieldType.Category, FieldType.Reason].includes(condition.fieldType)) {
    return c[condition.operation](ticket[condition.fieldCode], condition.targetValue)
  } else if (condition.fieldType == FieldType.Textarea) {
    return c[condition.operation](ticket[condition.fieldCode], condition.targetValue)
  } else if (condition.fieldType == FieldType.Boolean) {
    return c[condition.targetValue == ComparisonOperator.checked ?
      ComparisonOperator.includes : ComparisonOperator.notIncludes](ticket[condition.fieldCode], ComparisonOperator.checked)
  }
}

export const buildConditionTreeMap = (nodes: ConditionUnit[]) => {
  const nodeMap = nodes.reduce((map, node) => {
    map[node.id] = {
      ...node,
    } as ConditionUnit;
    return map;
  }, {} as Map<string, ConditionUnit>)

  nodes.filter((node) => node.level != 1).sort((s1, s2) => s2.level - s1.level).forEach((node) => {
    const parentId = node.parentId;
    const children = nodeMap[parentId]?.children ? nodeMap[parentId].children : []
    nodeMap[parentId] = {
      ...nodeMap[parentId],
      children: [...children, {...nodeMap[node.id], title: node.name }]
    }
  })

  return Object.values(nodeMap).filter((node) => node.level == 1)
}

export const flattenConditionTreeMap = (node) => {
  const children = retrieveTreeChildren(node)
  if (children?.length) {
    return [{ ...node, children: undefined}, ...children]
  } else {
    return [{ ...node, children: undefined}]
  }
}

export const retrieveTreeChildren = (node) => {
  const flatten = node?.children?.flatMap((child) => {
    return retrieveTreeChildren(child)
  })
  return flatten
}

export const typedOperations = {
  String: ["equal", "notEqual", "includes", "notIncludes", "startsWith", "endsWith"],
  ArrayString: ["includes", "notIncludes"],
  Number: ["equal", "notEqual", "biggerThan", "biggerEqual", "smallerThan", "smallerEqual"],
  SingleSelect: ["equal", "notEqual"],
  Radio: ["equal", "notEqual"],
  Checkbox: ["includes"],
  Boolean: ["equal"],
  Datetime: ["biggerThan", "biggerEqual", "smallerThan", "smallerEqual"],
  Date: ["biggerThan", "biggerEqual", "smallerThan", "smallerEqual"],
  Time: ["biggerThan", "biggerEqual", "smallerThan", "smallerEqual"],
  Textarea: ["includes", "notIncludes"],
  Category: ["equal", "notEqual"],
  Reason: ["equal", "notEqual"],
  Agent: ["equal", "notEqual"],
}

export const choiceHeaderFrom = (shop, ticket) => {
  const emails = Object.values(shop?.headerFroms || []) || []
  const names = Object.keys(shop?.headerFroms || []) || []
  let includedEmail = ''
  ticket?.emailTo?.forEach((to) => {
    emails.forEach((email: string, index) => {
      if (to == email || email?.includes(to) || to?.includes(email)) {
        includedEmail = buildHeaderFrom(names[index], email)
      }
    })
  })
  return !!includedEmail ? includedEmail : shop?.defaultHeaderFrom
}
